<template>
  <div class="measures-swiper-item-mian" :class="{ 'measures-swiper-item-mian-mobile': isMobile}">
    <div class="header-img"></div>
    <div class="content"></div>
  </div>
</template>
<script>
  export default { 
    name: 'MeasuresSwiperItem',
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
<style lang="scss" scoped>
  .measures-swiper-item-mian {
    display: flex;
    // border-radius: 0.03rem;
    height: 5.17rem;
    background: #fff;
    flex-direction: column;
    box-shadow: 0 0.03rem 0.16rem 0.03rem rgb(226 226 226 / 59%);
  }

  .header-img {
    width: 100%;
    height: 1.81rem;
    background: url('~assets/images/homePage/编组 7@2x.png');
    flex-shrink: 0;
  }

  .content {
    height: 100%;
  }
  .measures-swiper-item-mian-mobile {
    height: 19.87rem;
    .header-img {
      height: 6.96rem;
    }
  }
</style>
